import { render } from "./event-view-full.vue?vue&type=template&id=034fbcf6&scoped=true&lang=html"
import script from "./event-view-full.vue?vue&type=script&lang=js"
export * from "./event-view-full.vue?vue&type=script&lang=js"

import "./event-view-full.vue?vue&type=style&index=0&id=034fbcf6&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034fbcf6"]])

export default __exports__